import { baseURL } from '../../constants/Setting';
import { post, postData } from '../../util/Api';
import { DailyReport } from './DailyReportModel';

export interface Stamp {
  id: number;
  name: string; // スタンプ名
  path?: string; // スタンプ画像のパス
  emoji?: string; // 絵文字（オプショナル）
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
}

export class StampModel {
  static set(data: any): Stamp {
    const d: Stamp = {
      id: data.id,
      name: data.name,
      path: baseURL({ isPublic: true }) + '/' + data.path,
      emoji: data.emoji,
      created_at: data.created_at,
      updated_at: data.updated_at,
      deleted_at: data.deleted_at,
    };

    return d;
  }

  static async all(): Promise<Stamp[]> {
    const uri = '/stamps/all';
    let response = await postData(uri);

    if (response.status !== 200) {
      throw new Error();
    }

    const responseData = response.data;
    const stamps = Array.isArray(responseData)
      ? responseData.map((data: any) => this.set(data))
      : [this.set(responseData.data)];

    console.log(stamps);
    return stamps;
  }
}
